
import {Component, Prop, Vue} from "vue-property-decorator";
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import {UnitOption} from "@/models/Ingredient/UnitOption";
import {MergedNutrient} from "@/models/Ingredient/NutrientUnitList";
import {NutrientType} from "@/models/Ingredient/NutrientType";

@Component({
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class VIngredientNutrientQuantityInputRow extends Vue {
  @Prop() nutrientModel: MergedNutrient;

  @Prop() unitOptions: UnitOption[];
  @Prop({ default: false }) isIndented: boolean;
  @Prop({ default: false }) errorState: boolean;

  localizationState: LocalizationState;
  NutrientType = NutrientType;
  sugarAlcoholNutrientType = NutrientType.SugarAlcohols;

  get translations() {
    return this.localizationState.translations;
  }

  getChildNutrientNames(childNutrients : MergedNutrient[]){
    let childNames = '';
    childNutrients.forEach((nutrient) => {
      childNames += nutrient.name + ', ';
    });

    return childNames;
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  created() {
    this.$validator = this.$parent.$validator;
  }
}
